import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, CadastrarParametroLocalidadeRequest } from './types';

export function cadastrarParametroLocalidadeRequest(
	token: string,
	data: CadastrarParametroLocalidadeRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_PARAMETRO_LOCALIDADE,
		token,
		payload: data,
	};
}
export function cadastrarParametroLocalidadeSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_PARAMETRO_LOCALIDADE_SUCCESS,
		payload,
	};
}
export function cadastrarParametroLocalidadeFailure(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_PARAMETRO_LOCALIDADE_FAILURE,
		payload: null,
	};
}
export function cadastrarParametroLocalidadeClear(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_PARAMETRO_LOCALIDADE_CLEAR,
		payload: null,
	};
}
